import loadable from '@loadable/component';

/* istanbul ignore next */
export default loadable(
    () => import(/* webpackChunkName: "PromotionalFinancing" */ './PromotionalFinancing'),
    {}
);
